import { KText } from '@/ui-library/components/text';
import { Flex, Radio, RadioGroup } from '@chakra-ui/react';

export const YesNo = () => {
  return (
    <Flex gap="12px">
      <RadioGroup value={'yes'} cursor="not-allowed">
        <Radio variant="primary" value="yes" cursor="not-allowed">
          <KText fontSize="sm" mr="12px" cursor="not-allowed">
            Yes
          </KText>
        </Radio>
        <Radio variant="primary" value="no" cursor="not-allowed">
          <KText fontSize="sm" cursor="not-allowed">
            No
          </KText>
        </Radio>
      </RadioGroup>
    </Flex>
  );
};
